import styles from './MailModule.scss';
import { observer } from 'mobx-react-lite';
import { emailadsOptInStore } from 'owa-emailadsoptin-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getCurrentCulture } from 'owa-localize';
import { FolderPane } from 'owa-mail-folder-forest-view';
import { LeftnavStorageNotification } from 'owa-mail-leftnav-storage-notification';
import { LeftnavUpsell } from 'owa-mail-leftnavupsell';
import { MessageAdList } from 'owa-mail-messagead-list-view';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { lazyGetStorageStore } from 'owa-storage-store';
import * as React from 'react';
import {
    IsPremiumConsumerUser,
    IsChildConsumerUser,
    IsShadowMailboxUser,
    getCachedEUEmailPolicyOptInBit,
    isEUEmailAdsPolicyMarket,
    isEUEmailAdsPolicyFeatureEnabled,
} from 'owa-mail-ads-shared';

export default observer(function FolderPaneContainer() {
    const getStorageStore = lazyGetStorageStore.tryImportForRender();
    const usagePercentage = getStorageStore ? getStorageStore().usagePercentage : 0;

    // Value deciding whether to show the storage notification
    const showStorageNotification = usagePercentage >= 90;

    const showLeftNavPremiumUpsell =
        isConsumer() &&
        !IsShadowMailboxUser() &&
        isFeatureEnabled('auth-leftNavPremiumUpsell') &&
        !IsChildConsumerUser() &&
        getCurrentCulture().indexOf('jp') === -1 &&
        !showStorageNotification;

    return (
        <div className={styles.leftColumn}>
            <FolderPane />
            {isConsumer() &&
                !IsPremiumConsumerUser() &&
                !IsShadowMailboxUser() &&
                !IsChildConsumerUser() &&
                isEUEmailAdsPolicyFeatureEnabled() &&
                isEUEmailAdsPolicyMarket() &&
                (emailadsOptInStore.emailAdsOptInBit == 1 ||
                    emailadsOptInStore.emailAdsOptInBit == 0 ||
                    (emailadsOptInStore.emailAdsOptInBit == -1 &&
                        getCachedEUEmailPolicyOptInBit() == 1)) && (
                    <>
                        <MessageAdList
                            loadInOtherPivot={false}
                            loadInEmptyPivot={false}
                            loadInItemView={false}
                            tableView={null}
                        />
                    </>
                )}
            {showStorageNotification && (
                <LeftnavStorageNotification usagePercentage={usagePercentage} />
            )}
            {showLeftNavPremiumUpsell && <LeftnavUpsell />}
        </div>
    );
});
